import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {Grid} from 'semantic-ui-react';
import PlayerScoreboardHeader from './PlayerScoreboardHeader';
import PlayerScoreboardBody from './PlayerScoreboardBody';
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader';
import PausePopUp from "./PausePopUp/PausePopUp";
import {useSpring} from "react-spring";
import './ActiveGameScore.scss';
import {useAppDispatch, useAppSelector} from "../../../hooks/hooks";
import {getActiveGameScoreData} from "../../../store/pages/activeGameScore/toolkit/activeGameScoreSlice";
import {IActionGameScorePayload} from "../../../store/pages/activeGameScore/toolkit/types";
import { RootState } from "../../../store";
import { DartsGameStatus } from "../../../common/types/DartsGameStatuses";
import { StringToDartsGameType } from "../../../helpers/Mappers.helper";


const ActiveGameScore: React.FC = () => {
    const { leagueId, gameType } = useParams();
    //const {gameType} = useParams<{ gameType: string }>();
    const dispatch = useAppDispatch()
    const {activeGameData, loader} = useAppSelector((state: RootState) => state.activeGameScore)
    const connected = useAppSelector(state => state.connection.connection)
    const [isShowPopUp, setIsShowPopUp] = useState<boolean>(false)

    useEffect(() => {
        let id = Number(leagueId);
        let type = StringToDartsGameType(gameType);
        if (isNaN(id) || !type) {
            return;
        }
        if (connected) {
            const payload: IActionGameScorePayload = {
                gameId: id,
                gameType: type
            }
            dispatch(getActiveGameScoreData(payload))
        }
    }, [connected, leagueId, gameType]);

    useEffect(() => {
        if (activeGameData.legFinished && activeGameData.status === DartsGameStatus.Running) {
            setIsShowPopUp(true)
        }
    }, [activeGameData])

    const popUpStyle = useSpring({
        to: async (next) => {
            await next({
                opacity: isShowPopUp ? 1 : 0,
                display: isShowPopUp ? "flex" : "none",
            })
        },
        from: {opacity: 0, display: 'none'},
        config: {duration: 300}
    })

    return (
        <div>
            <PausePopUp
                animStyle={popUpStyle}
                legFinished={activeGameData.legFinished}
                setIsShowPopUp={setIsShowPopUp}
            />
            <Grid columns={"equal"} className="scoreboardStandard">
                {!loader && activeGameData && Object.keys(activeGameData).length !== 0 ? (
                    <>
                        <Grid.Row className="scoreboard_header">
                            <Grid.Column id="left_player">
                                <PlayerScoreboardHeader
                                    legsCount={activeGameData.legs[0]}
                                    isActive={activeGameData.playerId === activeGameData.players[0].id}
                                    remainingScore={activeGameData.scores[0]}
                                    playerName={activeGameData.players[0].name}/>
                            </Grid.Column>
                            <Grid.Column id="right_player">
                                <PlayerScoreboardHeader
                                    legsCount={activeGameData.legs[1]}
                                    isActive={activeGameData.playerId === activeGameData.players[1].id}
                                    remainingScore={activeGameData.scores[1]}
                                    playerName={activeGameData.players[1].name}
                                    reverse
                                />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row className="scoreboard_body">
                            <Grid.Column id="left_score">
                                <PlayerScoreboardBody
                                    turnData={activeGameData.turnScores ? activeGameData.turnScores[0] : []}
                                />
                            </Grid.Column>
                            <Grid.Column id="right_score">
                                <PlayerScoreboardBody
                                    turnData={activeGameData.turnScores ? activeGameData.turnScores[1] : []}
                                    reverse
                                />
                            </Grid.Column>

                        </Grid.Row>
                    </>
                ) : <OverlayLoader/>}
            </Grid>
            <div>

            </div>
        </div>
    );
}


export default ActiveGameScore;
ActiveGameScore.displayName = "Scoreboard";
